const styles = {
  dialogPaper: {
    borderRadius: "16px",
    overflow: "hidden",
    maxWidth: 440,
    width: "100%",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    position: "relative",
    background:
      "linear-gradient(135deg, #014339 0%, rgba(1, 67, 57, 0.85) 100%)",
    px: 3,
    py: 3,
    color: "white",
  },
  closeButton: {
    position: "absolute",
    top: 12,
    right: 12,
    color: "rgba(255,255,255,0.8)",
    "&:hover": { color: "white" },
    p: 0.5,
  },
  lockIconCircle: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    backgroundColor: "#F7EE6F",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  lockIcon: {
    fontSize: 20,
    color: "#014339",
  },
  headerSubtitle: {
    fontSize: "0.8rem",
    color: "rgba(255,255,255,0.75)",
    mt: 0.25,
  },
  content: {
    px: 3,
    py: 3,
    overflowY: "auto",
    flex: 1,
  },
  descriptionText: {
    fontSize: "0.9rem",
    color: "#374151",
    mb: 2.5,
  },
  progressBox: {
    backgroundColor: "#F9FAFB",
    borderRadius: "10px",
    px: 2,
    py: 1.75,
    mb: 2,
  },
  progressLabel: {
    fontSize: "0.8rem",
    fontWeight: 500,
    color: "#374151",
  },
  progressCount: {
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#014339",
  },
  progressBar: {
    height: "10px",
    borderRadius: "9999px",
    backgroundColor: "#E5E7EB",
    mt: 1,
    "& .MuiLinearProgress-bar": {
      background: "#014339",
      borderRadius: "9999px",
      transition: "width 0.5s ease",
    },
  },
  stepItem: (completed: boolean) => ({
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 1.5,
    py: 1.25,
    borderRadius: "8px",
    backgroundColor: completed ? "#F0FDF4" : "#F9FAFB",
  }),
  stepIcon: (completed: boolean) => ({
    fontSize: 18,
    color: completed ? "#16A34A" : "#9CA3AF",
    flexShrink: 0,
  }),
  stepLabel: (completed: boolean) => ({
    fontSize: "0.875rem",
    fontWeight: completed ? 500 : 400,
    color: completed ? "#14532D" : "#4B5563",
  }),
  benefitsBox: {
    backgroundColor: "rgba(247, 238, 111, 0.1)",
    border: "1px solid rgba(247, 238, 111, 0.35)",
    borderRadius: "10px",
    px: 2,
    py: 1.75,
    mb: 3,
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
  },
  crownIcon: {
    fontSize: 18,
    color: "#014339",
    mt: 0.25,
    flexShrink: 0,
  },
  benefitTitle: {
    fontWeight: 600,
    fontSize: "0.875rem",
    color: "#111827",
    mb: 0.75,
  },
  benefitItem: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "0.8rem",
    color: "#374151",
  },
  sparkleIcon: {
    fontSize: 11,
    color: "#014339",
  },
  actions: {
    display: "flex",
    gap: 1.5,
    px: 3,
    pb: 3,
  },
  closeBtn: {
    flex: 1,
    borderColor: "#E5E7EB",
    color: "#374151",
    "&:hover": { borderColor: "#D1D5DB", backgroundColor: "#F9FAFB" },
  },
  completeBtn: {
    flex: 1,
    backgroundColor: "#014339",
    color: "white",
    "&:hover": { backgroundColor: "rgba(1, 67, 57, 0.9)" },
  },
  arrowIcon: {
    fontSize: 14,
    ml: 0.75,
  },
};

export default styles;
